import { AvailableLanguage } from '@libs/core/i18n';

export const getEnvByLanguage = (language: AvailableLanguage, envKey: string) =>
  process.env[`${envKey}_${language.toUpperCase()}`] || process.env[envKey];
